import { render } from "./Projects.vue?vue&type=template&id=72d62701&scoped=true&ts=true"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"

import "./Projects.vue?vue&type=style&index=0&id=72d62701&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d62701"]])

export default __exports__